<template>
  <div>
    <ca-heading text="Sindicatos" />
    <ca-row>
      <ca-col>
        <ca-button theme="primary" @click="onNew">Novo sindicato</ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-async-content-wrapper
          :on-fetch="getUnions"
          :on-fetch-success="setUnions">
          <ca-table v-if="unions">
            <ca-tr slot="header">
              <ca-th>Nome</ca-th>
              <ca-th>CNPJ</ca-th>
              <ca-th>Cód. Sindical</ca-th>
              <ca-th>Compartilhado</ca-th>
              <ca-th></ca-th>
            </ca-tr>

            <ca-tr
              v-for="(union, index) in unions.content"
              :key="index"
              @click="onView(union.id)">
              <ca-td>
                {{ union.name }}
              </ca-td>
              <ca-td>
                {{ union.register }}
              </ca-td>
              <ca-td>
                {{ union.code }}
              </ca-td>
              <ca-td>
                {{ union.shared ? 'Sim' : 'Não' }}
              </ca-td>
              <ca-td>
                <ca-button
                  size="small"
                  class="ca-u-min-margin-right"
                  @click.stop="onEdit(union.id)">
                  Editar
                </ca-button>
                <ca-button
                  size="small"
                  @click.stop="onDelete(index, union.id)">
                  Remover
                </ca-button>
              </ca-td>
            </ca-tr>
          </ca-table>
        </ca-async-content-wrapper>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { getErrorMessageFromResponse } from 'packages/common';
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import {
  getUnions, deleteUnion,
} from './unionService';

export default {
  name: 'UnionsPage',
  data() {
    return {
      unions: null,
    };
  },
  created() {
    this.setUnions();
  },
  methods: {
    getUnions() {
      return getUnions();
    },
    setUnions(response) {
      this.unions = response;
    },
    onNew() {
      this.$router.push({ name: 'NewUnion' });
    },
    onView(id) {
      this.$router.push({ name: 'ViewUnion', params: { id } });
    },
    onEdit(id) {
      this.$router.push({ name: 'EditUnion', params: { id } });
    },
    onDelete(index, unionId) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteUnion(unionId)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.$delete(this.unions.content, index);
            })
            .catch(e => {
              this.$toaster.error(getErrorMessageFromResponse(e));
            });
        },
      });
    },
  },
};
</script>
